<template>
  <div>
    <div class="iframeContainer">
      <iframe
        width="100%"
        height="600"
        src="https://maps.google.com/maps?width=100%&amp;height=600&amp;hl=en&amp;q=%20Suite%20811%20Tsimshatsui%20Centre%2C%20East%20Wing%2C%2066%20Mody%20Road%2C%20Tsimshatsui%20East+(Internatonal%20Business%20Center)&amp;ie=UTF8&amp;t=&amp;z=17&amp;iwloc=B&amp;output=embed"
        frameborder="0"
        scrolling="no"
        marginheight="0"
        marginwidth="0"
      ></iframe>
    </div>

    <div class="separator"></div>

    <h1>{{ $t("contactUs.title") }}</h1>

    <div class="separator"></div>

    <div class="infoContainer">
      <div class="left">
        <div class="symbolContainer">
          <font-awesome-icon
            :icon="['fas', 'map-marker-alt']"
            size="2x"
            :style="{ color: 'white' }"
            fixed-width
          />
        </div>
        <h5>{{ $t("contactUs.address.title") }}</h5>
        <h6>{{ $t("contactUs.address.address") }}</h6>
      </div>

      <div class="right">
        <div class="symbolContainer">
          <font-awesome-icon
            :icon="['fas', 'phone']"
            size="2x"
            :style="{ color: 'white' }"
            fixed-width
          />
        </div>
        <h5>{{ $t("contactUs.phone.title") }}</h5>
        <h6>+852 2268 6888</h6>
      </div>
    </div>

    <div class="separator"></div>

    <div class="infoContainer">
      <div class="left">
        <div class="symbolContainer">
          <font-awesome-icon
            :icon="['fas', 'fax']"
            size="2x"
            :style="{ color: 'white' }"
            fixed-width
          />
        </div>
        <h5>{{ $t("contactUs.fax.title") }}</h5>
        <h6>+852 2721 3881</h6>
      </div>

      <div class="right">
        <div class="symbolContainer">
          <font-awesome-icon
            :icon="['fas', 'envelope']"
            size="2x"
            :style="{ color: 'white' }"
            fixed-width
          />
        </div>
        <h5>{{ $t("contactUs.email.title") }}</h5>
        <h6>
          <a
            href="mailto:info@ibchk.com?subject=Enquiry to International Business Center"
            >info@ibchk.com</a
          >
        </h6>
      </div>
    </div>

    <div class="separator"></div>

    <section>
      <p class="text contactUsFirst">
        <b>{{ $t("contactUs.p1") }}</b>
      </p>

      <p class="text contactUsSecond">
        {{ $t("contactUs.p2[0]") }}
      </p>

      <p class="text contactUsThird">{{ $t("contactUs.p3") }}</p>
    </section>
  </div>
</template>

<script>
export default {
  mounted() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
};
</script>

<style scoped>
.iframeContainer {
  width: 100%;
  height: 600px;
}

h1 {
  font-family: "Lato", sans-serif;
  font-weight: 500;
}

.text {
  font-family: "Lato", sans-serif;
  color: #646464;
  text-align: left;
  padding: 1rem;
}

.infoContainer {
  width: 80%;
  margin: auto;
  display: flex;
  background-color: #f0eded;
  padding: 1rem;
  border-radius: 0.5rem;
}

section {
  width: 80%;
  margin: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 1rem;
}

.infoContainer > div {
  width: calc(100% / 2);
}

.symbolContainer {
  background: black;
  border-radius: 50%;
  width: 5rem;
  height: 5rem;
  display: flex;
  justify-content: center;
  margin: auto;
  margin-bottom: 1rem;
}

.symbolContainer > svg {
  display: block;
  margin: auto;
}

h5 {
  font-weight: bolder;
}

h6 {
  font-weight: 300;
  line-height: 1.85rem;
}

.text {
  font-family: "Lato", sans-serif;
  color: #646464;
  text-align: left;
}

.contactUsFirst, .contactUsSecond, .contactUsThird {
  padding: 0;
}

.contactUsSecond, .contactUsThird {
  margin: 0;
}
</style>
